import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Banner from 'components/Banner';
import {
    fetchDetailTrialResults,
    selectDetailTrialResults,
    fetchTrialResultsPageList,
    selectTrialResultsPageList,
    fetchTrialResultsFlyers,
    selectTrialResultsFlyers,
    selectDetailTrialIsLoading,
} from 'store/slices/TrialResults';
import WithSidebar from 'Layout/WithSidebar';
import PDFBox from 'components/PDFBox';
import ProductSidebar from 'components/ProductSidebar';
import { ROUTES } from 'constants/routes';
import ButtonShowMore from 'components/Button/ButtonShowMore';
import { selectTranslations } from 'store/slices/GeneralTranslationsSlice';
import Preloader from 'Layout/Preloader';
import { useAnimation } from 'hooks/useAnimation';
import { scrollToSection } from 'helpers';

const DetailedTrialResults = () => {
    const dispatch = useDispatch();
    const { slug } = useParams();
    const [page, setPage] = useState(1);
    const { flyers, next } = useSelector(selectTrialResultsFlyers);
    const data = useSelector(selectDetailTrialResults);
    const crops = useSelector(selectTrialResultsPageList);
    const { sidebar_text_trials_result } = useSelector(selectTranslations);
    const loading = useSelector(selectDetailTrialIsLoading);

    const { title, fs_background, fs_view_button } = data;

    useEffect(() => {
        setPage(1);
        // @ts-ignore
        dispatch(fetchTrialResultsPageList({ all: true }));
        // @ts-ignore
        dispatch(fetchDetailTrialResults({ slug }));
        // @ts-ignore
    }, [dispatch, slug]);

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchTrialResultsFlyers({ slug, page }));
    }, [dispatch, page, slug]);

    const handleShowMore = () => setPage(page + 1);

    const handleClick = () => scrollToSection('this');

    const container = useRef();

    useAnimation({
        items: ['.box', '.product-sidebar'],
        container,
        dependencies: [loading],
    });

    if (loading) return <Preloader />;

    return (
        <div ref={container}>
            <Banner title={title} image={fs_background} buttonText={fs_view_button} onClickButton={handleClick} />
            <section className="container this">
                <WithSidebar
                    containerType="type-1"
                    mobileReversed
                    Sidebar={
                        <ProductSidebar
                            title={sidebar_text_trials_result}
                            data={crops}
                            baseRoute={ROUTES.trialResults}
                        />
                    }
                >
                    <PDFBox data={flyers}>
                        <ButtonShowMore onClick={handleShowMore} next={next} />
                    </PDFBox>
                </WithSidebar>
            </section>
        </div>
    );
};

export default DetailedTrialResults;
